import './Button.scss';
export function Button({ label, theme, enableHover = false }: ButtonProps) {
  return (
    <button
      type="button"
      className={`${theme === 'DARK' ? 'dark' : 'light'} ${enableHover ? 'hover-enabled' : ''}`}
    >
      {label}
    </button>
  );
}
export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}
interface ButtonProps {
  label: string;
  theme: Theme;
  enableHover?: boolean;
}
